import { isIOS } from 'react-device-detect';

import { useClientHasRendered } from '../hooks';

export const useIsIOS = (): boolean => {
  const clientHasRendered = useClientHasRendered();
  return clientHasRendered && isIOS;
};
